// extracted by mini-css-extract-plugin
export var content = "call-to-action-module--content--d5131";
export var contentWrap = "call-to-action-module--contentWrap--be85a";
export var extraRootPadding = "call-to-action-module--extraRootPadding--e5d5c";
export var overlay = "call-to-action-module--overlay--d7be6";
export var root = "call-to-action-module--root--8e6ad";
export var title = "call-to-action-module--title--a0b2b";